<template>
  <fb-main-body>
    <el-descriptions :title="$t('lang.个人信息')" :column="1">
      <el-descriptions-item :label="$t('lang.用户名')">{{ userInfo.name }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.账号')">{{ userInfo.account }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.角色')">{{ userInfo.roleName }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.状态')">{{ userInfo.statusName }}</el-descriptions-item>
    </el-descriptions>
  </fb-main-body>
</template>

<script>
export default {
  name: "PersonageDetail",
  data() {
    return {}
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    }
  }
}
</script>

<style scoped>

</style>
